import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, QueryList, SimpleChanges, ViewChild, ViewChildren } from '@angular/core';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { JsignalService } from 'src/app/shared/services/jsignal.service';
import { LocalStorageSettingsService } from 'src/app/shared/services/local-storage-settings.service';
import { MandatoryCommentsPopupComponent } from '../mandatory-comments-popup/mandatory-comments-popup.component';
import { MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';

@Component({
    selector: 'app-stepper-form',
    templateUrl: './stepper-form.component.html',
    styleUrls: ['./stepper-form.component.scss'],
    standalone: false
})
export class StepperFormComponent implements OnChanges  {

  @Input() jsonData: any;
  @Input() role: 'author' | 'reviewer' | 'approver' = 'reviewer';
  // below Input Receives the No. Of Open Comments in each section 
  @Input() commentCountMap: { [sectionId: string]: number } = {};
   // below Input Receives the total No. Of Open Comments in Full CommentJson From Review-Approve Component 
  @Input() totalOpenComments : any;
  //this StrategyId is string common for all version  
  @Input() StrategyId: any;
  @Input() isPreview: boolean = false;
  @Input() pssState: string;
  // This pssId is unique for each Pss
  @Input() pssID: any;
  

  @Output() update = new EventEmitter<any>();  // emits updated JSON
  @Output() save =  new EventEmitter<any>();
  @Output() cancel = new EventEmitter<boolean>();
  @Output() sectionId = new EventEmitter<any>();
  @Output() SubmitDraft =  new EventEmitter<any>();
  @ViewChild('previewContainer') previewContainer!: ElementRef;
  @ViewChildren('autoArea') textareas!: QueryList<ElementRef<HTMLTextAreaElement>>;


  json: any;                 // normalized object used in template
  sectionTitles: string[] = [];
  selectedSectionIndex = 0;  // default first section
  backgroundColorButton = '';  
  isProgrammaticScroll = false;
  isEditing = false;
  buttonColor = "";
  resizeObserver: ResizeObserver | null = null;
  ignoreNextScroll = false;
  //default line limit 
  truncateLimit = 50;

  constructor(private cdr: ChangeDetectorRef,private localStorage: LocalStorageSettingsService,private snackBar: MatSnackBar, private jsignalsService: JsignalService,private spinner: NgxUiLoaderService,private dialog: MatDialog,) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes.jsonData) this.normalizeJson();
    if (changes.jsonData || changes.role) this.cdr.markForCheck();
     this.backgroundColorButton = this.localStorage.getSettings('ColorA');
     this.buttonColor = this.localStorage.getSettings("ColorA");
      console.log('Stepper received commentCountMap:', this.commentCountMap);

      //pss state recevied from parent component
      console.log(this.pssState);
      console.log(this.pssID);
      console.log(this.role);
      console.log(this.totalOpenComments);


  }

  ngOnDestroy(): void {
  this.resizeObserver?.disconnect();
  }

  ngAfterViewInit(): void {
    
    // default select first section
  this.selectedSectionIndex = 0;
    // Emit first section immediately
  this.emitSectionChange(this.selectedSectionIndex);
    // listen to scroll
  const container = this.previewContainer.nativeElement;
    container.addEventListener('scroll', () => {
      if (!this.isProgrammaticScroll) {
          this.onScroll();
            }
    });
      // listen to scrollend (unlock after programmatic scroll finishes)
  container.addEventListener('scrollend', () => {
    this.isProgrammaticScroll = false;
  });

  // Run after Angular renders all textareas
    setTimeout(() => {
      this.textareas.forEach((textareaRef) => {
        this.autoResize(textareaRef.nativeElement);
      });
    });

  }
  


// onScroll(): void {
//   if (this.isProgrammaticScroll || this.isEditing) return;

//   const container = this.previewContainer.nativeElement;
//   const sections = container.querySelectorAll('.section');

//   let currentIndex = 0;
//   const scrollPosition = container.scrollTop + container.clientHeight / 3;

//   sections.forEach((section: any, index: number) => {
//     if (section.offsetTop <= scrollPosition) {
//       currentIndex = index;
//     }
//   });

//   // handle bottom edge (last section visible)
//   const nearBottom =
//     container.scrollTop + container.clientHeight >= container.scrollHeight - 5;
//   if (nearBottom) {
//     currentIndex = sections.length - 1;
//   }

//   if (currentIndex !== this.selectedSectionIndex) {
//     // 👇 release focus if user was editing
//     if (this.isEditing) {
//       this.isEditing = false;
//       (document.activeElement as HTMLElement)?.blur();
//     }

//     this.selectedSectionIndex = currentIndex;
//     this.emitSectionChange(currentIndex);
//   }
// }

//    // left side click => scroll center
// scrollToSection(index: number): void {
//     //  release focus before moving
//   this.releaseFocusIfSectionChanged(index);

//   this.selectedSectionIndex = index;

//   const el = document.getElementById('section-' + index);
//   const container = document.getElementById('preview-container');

//   this.isProgrammaticScroll = true;
//   this.isEditing = false;   // <-- reset editing state

//   if (el && container) {
//     // element position relative to the container
//     const elRect = el.getBoundingClientRect();
//     const containerRect = container.getBoundingClientRect();

//     // how far the section is inside the container
//     const relativeTop = elRect.top - containerRect.top;

//     container.scrollTo({
//       top: container.scrollTop + relativeTop, // scroll by relative offset
//       behavior: 'smooth'
//     });
//   }

//   this.emitSectionChange(index);
// }

onScroll(): void {
  if (this.isProgrammaticScroll || this.isEditing) return;

  const container = this.previewContainer.nativeElement;
  const sections = container.querySelectorAll('.section');

  let currentIndex = this.selectedSectionIndex;
  const containerMid = container.scrollTop + container.clientHeight / 2; // use mid viewport

  sections.forEach((section: any, index: number) => {
    const sectionTop = section.offsetTop;
    const sectionHeight = section.offsetHeight;

    // section is "active" if container middle lies inside it
    if (containerMid >= sectionTop && containerMid < sectionTop + sectionHeight) {
      currentIndex = index;
    }
  });

  // handle bottom edge
  const nearBottom =
    container.scrollTop + container.clientHeight >= container.scrollHeight - 5;
  if (nearBottom) {
    currentIndex = sections.length - 1;
  }

  if (currentIndex !== this.selectedSectionIndex) {
    this.releaseFocusIfSectionChanged(currentIndex);
    this.selectedSectionIndex = currentIndex;
    this.emitSectionChange(currentIndex);
  }
}

scrollToSection(index: number): void {
  this.releaseFocusIfSectionChanged(index);
  this.selectedSectionIndex = index;

  const el = document.getElementById('section-' + index);
  const container = this.previewContainer?.nativeElement;

  this.isProgrammaticScroll = true;
  this.isEditing = false;

  if (el && container) {
    // Smoothly scroll so that section comes to center (not forced to top)
    const elRect = el.getBoundingClientRect();
    const containerRect = container.getBoundingClientRect();
    const relativeTop = elRect.top - containerRect.top;

    container.scrollTo({
      top: container.scrollTop + relativeTop - container.clientHeight / 4,
      behavior: 'smooth'
    });
  }

  this.emitSectionChange(index);
}






  get data() {
    return this.jsonData ? this.jsonData[0] : null;
  }

  // Finds the actual array inside the section (DocControl, productOV, section1, etc.)
  getSectionArray(section: any): any[] {
    const keys = Object.keys(section).filter(k => !['Section Title','Section Type'].includes(k));
    return section[keys[0]] || [];
  }

  // Extracts table headers from first row
  getTableHeaders(section: any): string[] {
    const arr = this.getSectionArray(section);
    return arr.length > 0 ? Object.keys(arr[0]) : [];
  }

   // Normalize input to object and fill section titles
  normalizeJson() {
    if (!this.jsonData) { this.json = null; this.sectionTitles = []; return; }
    try {
      // If input is string, parse; if array - take first element as you used earlier
      let parsed = this.jsonData;
      if (typeof parsed === 'string') parsed = JSON.parse(parsed);
      if (Array.isArray(parsed) && parsed.length) parsed = parsed[0];
      this.json = parsed;
    } catch (e) {
      // fallback: use as-is
      this.json = this.jsonData;
    }

    this.sectionTitles = (this.json && Array.isArray(this.json.sections))
      ? this.json.sections.map((s: any) => s['Section Title'] || 'Untitled')
      : [];
  }

  // Editing helpers (works on this.json in-place)
  trackByIndex(i: number) { return i; }

  // Add/remove rows for key-value sections (DocControl/productOV)
  addKeyValueRow(section: any) {
    if (this.role !== 'author') return;
    const arr = this.getSectionArray(section);
    arr.push({ Column1: '', Column2: '' });
  }
  removeKeyValueRow(section: any, i: number) {
    if (this.role !== 'author') return;
    const arr = this.getSectionArray(section);
    arr.splice(i, 1);
  }

  // Table add/remove row
  addTableRow(section: any) {
    if (this.role !== 'author') return;
    const arr = this.getSectionArray(section);
    // create a blank row preserving same keys as headers
    const headers = this.getTableHeaders(section);
    const newRow: any = {};
    headers.forEach(h => newRow[h] = '');
    arr.push(newRow);
  }
  removeTableRow(section: any, rIndex: number) {
    if (this.role !== 'author') return;
    const arr = this.getSectionArray(section);
    arr.splice(rIndex, 1);
  }

  // Add a new column to a table section (adds empty value to each row)
  addTableColumn(section: any, newColName: string) {
    if (this.role !== 'author' || !newColName) return;
    const arr = this.getSectionArray(section);
    // avoid duplicate
    const headers = this.getTableHeaders(section);
    if (headers.includes(newColName)) return;
    arr.forEach((row: any) => row[newColName] = '');
  }

  // Activities helpers: add/remove activity row
  addActivityRow(section: any) {
    if (this.role !== 'author') return;
    const arr = this.getSectionArray(section);
    arr.push({
      activity: '',
      level: '',
      reviewPeriod: 'Monthly',
      dueDays: 30,
      originalReviewPeriod: 'Monthly',
      originalDueDays: 30,
      durationHours: 0,
      durationMinutes: 0,
      durationSeconds: 0,
      evidenceRequired: 'No',
      uploadInstructions: '',
      rolesAllowed: '',
      startDate: null
    });
  }
  removeActivityRow(section: any, idx: number) {
    if (this.role !== 'author') return;
    const arr = this.getSectionArray(section);
    arr.splice(idx, 1);
  }

  // Save: emit deep clone of JSON (so parent gets a clean object)
  Update() {
    if (this.role !== 'author') return;
    // ensure we preserve the same structure & ordering — emit clone of this.json
    const cloned = JSON.parse(JSON.stringify(this.json));
    this.update.emit(cloned);
  }

  SaveJSon(){
    
    // ensure we preserve the same structure & ordering — emit clone of this.json
    const cloned = JSON.parse(JSON.stringify(this.json));
    this.save.emit(cloned);

  }

  
onSubmit() {
  const cloned = JSON.parse(JSON.stringify(this.json));
  this.SubmitDraft.emit(cloned);
}



  onCancel() {
    this.cancel.emit(true);
  }
  updateTextSection(event: any, section: any) {
  const lines = event.target.value.split('\n');
  const key = Object.keys(section).find(k => k !== 'Section Title' && k !== 'Section Type');
  if (key) {
    section[key] = lines;
  }
}
emitSectionChange(index: number) {
  if (!this.json || !this.json.sections || !this.json.sections[index]) return;

  const section = this.json.sections[index];
  const sectionId = section['Section Title'] || `section-${index}`; // use title as ID
    // 🔴 also check here (for sidebar clicks)
  this.releaseFocusIfSectionChanged(index);

  this.sectionId.emit(sectionId);  // emits to parent
}

/** returns numeric count (0 if none). Tries index, then section title, then section id-like keys */
getCommentCount(si: number, section: any): number {
  if (!this.commentCountMap) return 0;

  // 1) try numeric index key
  if (typeof this.commentCountMap[si] !== 'undefined') {
    return Number(this.commentCountMap[si]) || 0;
  }

  // 2) try section title key (some apps emit counts keyed by title)
  const titleKey = section && section['Section Title'];
  if (titleKey && typeof this.commentCountMap[titleKey] !== 'undefined') {
    return Number(this.commentCountMap[titleKey]) || 0;
  }

  // 3) try a fallback id-like key if you emit keys like 'section-0'
  const fallbackKey = `section-${si}`;
  if (typeof this.commentCountMap[fallbackKey] !== 'undefined') {
    return Number(this.commentCountMap[fallbackKey]) || 0;
  }

  return 0;
}

//below code is used for live document update it emits on every changes 
// add (ngModelChange)="emitUpdate()" in input to use 

// emitUpdate() {
//   // always emit a fresh clone to avoid reference issues
//   const cloned = JSON.parse(JSON.stringify(this.json));
//   this.update.emit(cloned);
// }

// onComplete(){
//   this.openCommentsPopup('complete');
//   this.spinner.start();
//   //below pssID is unique id 
//   console.log(this.pssID);
//   //below PSSID is Common PSSID For all version
//   const PSSID = this.StrategyId;
//   console.log(PSSID);
//   this.jsignalsService.reviewComplete(this.pssID,"SUBMIT").subscribe({
//     next: (res:any) => {
//        this.snackBar.open(res.statusMessage, 'Ok', { duration: 3000 });
//        this.onCancel();
//        this.spinner.stop();

       
//     },
//     error: (err) => {
//       console.error(err);
//       this.snackBar.open(err.error.statusMessage, 'Ok', { duration: 3000 });
//       this.onCancel();
//       this.spinner.stop();
//     }
//   });
// }

// onApprove(){
//    this.openCommentsPopup('approve');

//   this.spinner.start();
//   //below pssID is unique id 
//   console.log(this.pssID);

//   this.jsignalsService.approveAction(this.pssID,"SUBMIT").subscribe({
//     next: (res:any) => {
//        this.snackBar.open(res.statusMessage, 'Ok', { duration: 3000 });
//        this.onCancel();
//        this.spinner.stop();

       
//     },
//     error: (err) => {
//       console.error(err);
//       this.snackBar.open(err.error.statusMessage, 'Ok', { duration: 3000 });
//       this.onCancel();
//       this.spinner.stop();
//     }
//   });

// }

onComplete() {
  this.openCommentsPopup('complete').subscribe(comments => {
    if (comments) {
      this.submitComplete(comments);
    }
  });
}

onApprove() {
    if (this.totalOpenComments > 0) {
    this.snackBar.open(
      `Approval cannot proceed. ${this.totalOpenComments} comment(s) are still open. Please Close all comments before approving.`,
      'Close',
      {
        duration: 5000,
        panelClass: ['snackbar-error'] // style in CSS
      }
    );
    return;
  }
  this.openCommentsPopup('approve').subscribe(comments => {
    if (comments) {
      this.submitApprove(comments);
    }
  });
}

onReject(){
  this.spinner.start();

  console.log(this.StrategyId);

  this.jsignalsService.approveAction(this.StrategyId,"REJECT","REJECTED").subscribe({
    next: (res:any) => {
       this.snackBar.open(res.statusMessage, 'Ok', { duration: 3000 });
       this.onCancel();
       this.spinner.stop();

       
    },
    error: (err) => {
      console.error(err);
      this.snackBar.open(err.error.statusMessage, 'Ok', { duration: 3000 });
      this.onCancel();
      this.spinner.stop();
    }
  });

}
/** Helper: blur active element if it's in another section */
private releaseFocusIfSectionChanged(newIndex: number) {
  const active = document.activeElement as HTMLElement;
  if (
    active &&
    (active.tagName === 'INPUT' ||
      active.tagName === 'TEXTAREA' ||
      active.isContentEditable)
  ) {
    const currentSection = active.closest('.section');
    const newSection = document.getElementById(`section-${newIndex}`);
    if (currentSection && newSection && currentSection !== newSection) {
      active.blur();
      this.isEditing = false;
    }
  }
}

openCommentsPopup(action: 'complete' | 'approve'): Observable<string | null> {
  const dialogRef = this.dialog.open(MandatoryCommentsPopupComponent, {
        maxWidth: "100vw",
        height: "55%",
        width: "45%",
        disableClose: true,
        autoFocus: false, 
    data: {
      pssID: this.pssID,
      strategyID: this.StrategyId,
      action
    }
  });

  return new Observable(observer => {
    dialogRef.afterClosed().subscribe((comments: string | null) => {
      observer.next(comments);
      observer.complete();
    });
  });
}
// Review complete 
submitComplete(comments: string) {
    if (this.totalOpenComments > 0) {
    const confirmed = confirm(
      `There are still ${this.totalOpenComments} open comment(s). Are you sure you want to complete the review?`
    );

    if (!confirmed) {
      return; //  Stop if user cancels
    }
  }
  this.spinner.start();
  this.jsignalsService.reviewComplete(this.StrategyId, comments).subscribe({
    next: res => {
      this.snackBar.open(res.statusMessage, 'Ok', { duration: 3000 });
      this.onCancel();
      this.spinner.stop();
    },
    error: err => {
      console.error(err);
      this.snackBar.open(err.error.statusMessage, 'Ok', { duration: 3000 });
      this.onCancel();
      this.spinner.stop();
    }
  });
}
//Approve Document 
submitApprove(comments: string) {
  this.spinner.start();
  this.jsignalsService.approveAction(this.StrategyId, "SUBMIT",comments).subscribe({
    next: res => {
      this.snackBar.open(res.statusMessage, 'Ok', { duration: 3000 });
      this.onCancel();
      this.spinner.stop();
    },
    error: err => {
      console.error(err);
      this.snackBar.open(err.error.statusMessage, 'Ok', { duration: 3000 });
      this.onCancel();
      this.spinner.stop();
    }
  });
}

isArray(val: any): boolean {
  return Array.isArray(val);
}

isString(val: any): boolean {
  return typeof val === 'string';
}

isObject(val: any): boolean {
  return val && typeof val === 'object' && !Array.isArray(val);
}

objectKeys(obj: any): string[] {
  return Object.keys(obj || {});
}

/**
 * Returns true when value contains a newline character.
 * Safe for non-strings.
 */
isMultiline(value: any): boolean {
  if (value === null || value === undefined) return false;
  return String(value).indexOf('\n') !== -1;
}

/**
 * Returns true if the text length is greater than limit.
 */
isTruncated(value: any, limit = 80): boolean {
  if (value === null || value === undefined) return false;
  return String(value).length > limit;
}

/**
 * Tooltip text (full text). Convert null/undefined to empty string.
 */
getTooltipText(value: any): string {
  if (value === null || value === undefined) return '';
  return String(value);
}

autoResize(textarea: HTMLTextAreaElement): void {
  if (!textarea) return;
  textarea.style.height = 'auto'; // reset height first
  textarea.style.height = textarea.scrollHeight + 'px'; // grow to fit content
}

}

